export const serverContextPath = "";
